module.exports = __webpack_public_path__ + "static/img/24美佳.2c13527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/24美佳.jpg
// module id = K1EY
// module chunks = 0